import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import Moment from "moment";
import echarts from "echarts";
import { extendMoment } from "moment-range";
import Antd from "ant-design-vue";
import "ant-design-vue/dist/antd.css";
import Print from "vue-print-nb";
import "echarts/lib/chart/line";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/title";

Vue.use(Print);
Vue.use(Antd);

Vue.config.productionTip = false;

const moment = extendMoment(Moment);

Vue.prototype.$echarts = echarts;
Vue.prototype.$moment = moment;
Vue.prototype.$axios = axios;

axios.defaults.headers.post["Content-Type"] = "application/json";

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
